import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';

import { AWSAccountID } from './filters/AWSAccountID';
import { AWSResourceType } from './filters/AWSResourceType';

/**
 * Get simple filter definitions for AWSResource entity
 * Returns filter names mapped to available values and operators
 *
 * @returns Array of field names to SimpleFilterDefinition
 */
export function getAWSResourceSimpleFilters(): SimpleFilterDefinition[] {
  return [AWSResourceType, AWSAccountID];
}
